import React from 'react';
import { CondensedHeader } from '@axiom/ui';
import type { TalentSearchDisplayFiltersCategory } from '@axiom/validation';

import { TalentSearchFilterUtil } from '../../utils/talent-search-filter-util';

import { TalentSearchFiltersCheckboxes } from './TalentSearchFiltersCheckboxes';

export interface TalentSearchFiltersAdmissionsGroupingsProps {
  data: TalentSearchDisplayFiltersCategory;
  disabled: boolean;
  parentIndex: number;
}

export const TalentSearchFiltersAdmissionsGroupings = ({
  data,
  disabled,
  parentIndex,
}: TalentSearchFiltersAdmissionsGroupingsProps) => {
  const possibleCategories =
    TalentSearchFilterUtil.categorizeBarredLocationsItems(data);

  return Object.values(possibleCategories).map(category => {
    return (
      <div key={category.id} data-test="admissions-group">
        <CondensedHeader name={`${category.name}_header`}>
          {category.name}
        </CondensedHeader>
        <TalentSearchFiltersCheckboxes
          data={category.item}
          disabled={disabled}
          parentIndex={parentIndex}
        />
      </div>
    );
  });
};
